
const initialStateSave = {
  loading: false,
  showModal: false,
};

export function fetchRentalDeliveryPlanning(state = initialStateSave, action) {
  switch(action.type) {
    case 'FETCH_RENTAL_DELIVERY_PLANNING.SUCCESS':
      return {
        ...state,
        planning: action.planning.body
      };
    default:
      return state;
  }
}

export function fetchRentalReporting(state = initialStateSave, action) {
  switch(action.type) {
    case 'FETCH_RENTAL_REPORTING.SUCCESS':
      return {
        ...state,
        reporting: action.reporting.body
      };
    case 'HIDE_DELIVERY_MODAL':
      return {
        ...state,
        showModal: false
      };
    case 'SHOW_DELIVERY_MODAL':
      return {
        ...state,
        showModal: true
      };
    default:
      return state
  }
}

export function deliverRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'DELIVER_RENTAL_VEHICLE.SUCCESS':
      return {
        ...state,
        report: action.report.body
      };
    default:
      return state
  }
}

export function returnRentalVehicle(state = initialStateSave, action) {
  switch(action.type) {
    case 'RETURN_RENTAL_VEHICLE.SUCCESS':
      return {
        ...state,
        report: action.report.body
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rentalReporting.js